import React, { useEffect, useState } from "react";
import { CModal, CModalBody } from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { hideAddFaqsModal, showAddFaqsModal } from "../redux/faqsModalDispatcher";
import { addFaqsRequest } from "../redux/faqsDispatcher";

// CKEditor imports
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const AddFaqs = ({
  buttonLabel = "Add Faq",
  editMode = false,
  faqsData = {},
}) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  useEffect(() => {
    if (editMode && faqsData) {
      setQuestion(faqsData.question || "");
      setAnswer(faqsData.answer || "");
    }
  }, [editMode, faqsData]);

  const resetForm = () => {
    setQuestion("");
    setAnswer("");
  };

  const handleAddFaqs = () => {
    if (question.trim() === "") {
      alert("Question is required");
      return;
    }

    if (answer.trim() === "") {
      alert("Answer is required");
      return;
    }

    const data = {
      question,
      answer,
    };

    if (editMode) {
      data.id = faqsData.id;
    }

    dispatch(addFaqsRequest(data));
    resetForm();
    setIsModalVisible(false);
    dispatch(hideAddFaqsModal());
  };

  return (
    <div>
      {/* Open Modal Button */}
      <button
        onClick={() => {
          if (!editMode) resetForm();
          setIsModalVisible(true);
          dispatch(showAddFaqsModal());
        }}
        style={{
          backgroundColor: editMode ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode ? "10px" : "14px",
          minWidth: "60px",
          height: editMode ? "24px" : "30px",
          padding: editMode ? "2px 5px" : "4px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {buttonLabel}
      </button>

      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        className="attributemodal"
      >
        <CModalBody className="main-container createAdmin">
          {/* Close Button */}
          <div className="cross-btn-div d-flex">
            <img
              onClick={() => setIsModalVisible(false)}
              src={crossButton}
              alt="close"
              className="cross-button"
            />
          </div>

          <form onSubmit={(e) => e.preventDefault()} className="login-form">
            <div className="mb-4">
              <h4 className="h4 fw-bold" style={{ color: "#007bff", textAlign: "center" }}>
                <b>{editMode ? "Edit FAQ" : "Add FAQ"}</b>
              </h4>
            </div>

            {/* Question Input */}
            <div className="mb-3 input-login-box">
              <input
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                name="question"
                type="text"
                className="form-control login-input"
                placeholder="Enter question"
              />
            </div>

            {/* CKEditor for Answer */}
            <div className="mb-3 input-login-box my-ckeditor">
              <label htmlFor="answer" className="form-label">Answer</label>
              <CKEditor
                editor={ClassicEditor}
                data={answer}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setAnswer(data);
                }}
              />
            </div>

            {/* Submit Button */}
            <button
              className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
              type="button"
              onClick={handleAddFaqs}
            >
              {editMode ? "Update" : "Submit"}
            </button>
          </form>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddFaqs;
